import { render, staticRenderFns } from "./RecomendedItems.vue?vue&type=template&id=7577a440&scoped=true&"
import script from "./RecomendedItems.vue?vue&type=script&lang=js&"
export * from "./RecomendedItems.vue?vue&type=script&lang=js&"
import style0 from "./RecomendedItems.vue?vue&type=style&index=0&id=7577a440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7577a440",
  null
  
)

export default component.exports